<template>
  <div qaid="warranty-issue-types-panel">
    <trek-button text icon-only icon="close" class="absolute top-0 right-0 mt-2 mr-2" @click="closeTooltip">
    </trek-button>

    <section-header class="my-2">
      <heading class="font-bold text-left" v-html="bp('pleaseSelect')" />
    </section-header>

    <div v-if="hasParentIssue" class="my-1">
      <div class="flex items-center text-left" @mouseup.prevent="goBack">
        <i class="material-icons md-24">chevron_left</i>
        <span v-html="bp('back')" />
      </div>
    </div>

    <div class="b2b-scroll-list-container min-w-xs">
      <div class="b2b-scroll-list">
        <div v-for="(issue, index) in paginatedData" :key="index">
          <div
            v-if="hasSubIssues(issue)"
            class="flex justify-between items-center border-t border-gray-10 text-left p-1"
            @mouseup.prevent="selectSubIssue(issue)"
          >
            <span v-html="issue.warrantyUfoName" />
            <i class="material-icons md-24">chevron_right</i>
          </div>
          <div
            v-else
            class="border-t border-gray-10 text-left p-1 pr-5"
            @mouseup.prevent="selectIssue(issue)"
            v-html="issue.warrantyUfoName"
          />
        </div>
      </div>
    </div>

    <div class="py-1">
      <pagination
        v-if="pageCount > 1"
        ref="pagination"
        :page-number="pageNumber"
        :page-count="pageCount"
        @page-change="pageChange"
        @prev-page="prevPage"
        @next-page="nextPage"
      ></pagination>
    </div>
  </div>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import Heading from '@/components/Heading';
import pagination from '@/mixins/pagination';
import SectionHeader from '@/components/SectionHeader';

export default {
  components: {SectionHeader, Heading, TrekButton},
  mixins: [pagination],

  props: {
    baseProperties: {
      type: Array,
      required: true,
    },
    warrantyIssues: {
      type: Array,
      required: true,
    },
    resetIssues: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: Number,
      default: 100,
      required: false,
    },
  },

  data() {
    return {
      currentIssues: this.warrantyIssues,
      parentIssues: [],
      parentPage: [],
    };
  },

  computed: {
    listData() {
      return this.currentIssues ? this.currentIssues : [];
    },

    hasParentIssue() {
      return this.parentIssues && this.parentIssues.length;
    },
  },

  watch: {
    resetIssues() {
      if (this.resetIssues) this.currentIssues = this.warrantyIssues;
    },
  },

  methods: {
    hasSubIssues(issue) {
      return issue.warrantyIssueTypes && issue.warrantyIssueTypes.length;
    },

    selectIssue(issue) {
      this.parentIssues = [];
      this.parentPage = [];
      this.currentIssues = this.warrantyIssues;
      this.pageNumber = 0;

      this.$emit('issue-selected', issue.warrantyUfoName);
    },

    selectSubIssue(issue) {
      this.parentIssues.push(this.currentIssues);
      this.parentPage.push(this.pageNumber);
      this.pageNumber = 0;
      this.currentIssues = issue.warrantyIssueTypes;
    },

    goBack() {
      this.currentIssues = this.parentIssues.pop();
      this.pageNumber = this.parentPage.pop();
    },

    closeTooltip() {
      let el = this.$parent.$refs.tippy;

      if (el && el._tippy) {
        el._tippy.hide();
      }
    },
  },
};
</script>
